module.exports = __webpack_public_path__ + "img/search.ee1da97c.svg";